import simpleParallax from "simple-parallax-js";

export class StudyTour {
	
	
	constructor(app) {
		this.app = app;
		this.initSlider();
		this.initScroll()
		this.initTextAnimation();
		this.initOpen();
		this.initAnimation();
		
		
	}
	
	initAnimation() {
		
		var images = document.querySelectorAll('[data-para]');
		new simpleParallax(images, {
			overflow: true,
			scale: 1.2
		});
		
	}
	
	initOpen() {
		$('._nav-link__head').click(e=>{
			$('._nav-link').toggleClass('is-open');
		});
		// $('.cc-high6__head').click(e => {
		// 	$(e.currentTarget).closest('.cc-high6__cource').toggleClass('is-open');
		// });
		// $('.cc-color2__btn').click(e => {
		// 	$(e.currentTarget).closest('.cc-color2__project').toggleClass('is-open');
		// });
	}
	
	initScroll() {
		var h = document.querySelector('.st-mv').offsetHeight;
		$(window).scroll(e=>{
			if(window.scrollY > h){
				document.body.classList.add('is-scroll-hide-mv');
			}else{
				document.body.classList.remove('is-scroll-hide-mv');
			}
		}).trigger('scroll');
		
		
		$('._nav-link__link').click(this.app.scroll);
		$('._nav-link__link').click(e=>{
			$('._nav-link').removeClass('is-open');
		});
	}
	
	initTextAnimation(){
		var elements = $('[data-aos="split-text"]');
		
		this.app.initTextAnimation(elements);
		setTimeout(()=>{
			document.querySelector('.st-mv__ttl').classList.remove('aos-animate');
			document.querySelector('.st-mv__ttl').style.display = 'block';
		},100);
		setTimeout(()=>{
			document.querySelector('.st-mv__ttl').classList.add('aos-animate');
		},1500);
		
	}
	
	initSlider() {
		
		var mvSlick = $('.st-mv__slide');
		mvSlick.slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 1500,
			fade: true,
			cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
		});
		
		
		var destSlick = $('.st-dest__list');
		destSlick.slick({
			arrows: true,
			autoplay: true,
			autoplaySpeed: 2000,
			speed: 1200,
			cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
		});
		 
		destSlick.on('beforeChange', function(slick,currentSlide,current,next) {
			var l = currentSlide.$slides.length;
			if(current == l-1 && next ==0){
				setTimeout(function(){
					$('.st-dest__list [data-slick-index="'+current+'"]').next().addClass('slick-current');
				},1);
			}
			if(current == 0 && next == l-1){
				setTimeout(function(){
					$('.st-dest__list [data-slick-index="'+-1+'"]').addClass('slick-current');
				},1);	
			}
		});
		
		
		// var resultSlick = $('.st-result-slide__list');
		// resultSlick.slick({
		// 	arrows: true,
		// 	speed: 1200,
		// 	cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
		// });

		
		//SP-ONLY
		if (this.app.isSmartPhone()) {
			var overviewSlick = $('.st-overview__photos');
			overviewSlick.slick({
				infinite: true,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 2000,
				speed: 1000,
				slidesToShow: 1,
				cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
			});
			$('.st-flow__btn').click(e=>{
				var $wrap = $(e.currentTarget).closest('.st-flow');
				
				var h = $wrap.find('.st-flow-list').height();
				$wrap.find('.st-flow__body').animate({
					height: h
				},500);
				
				setTimeout(()=>{
					$wrap.addClass('is-open');
				},500);
				
			});
		}
		//PC ONLY
		if (!this.app.isSmartPhone()) {
			var flowSlick = $('.st-flow-list').not('.is-not-slide');
			flowSlick.slick({
				infinite: false,
				arrows: true,
				speed: 800,
				slidesToShow: 1,
				variableWidth: true,
				cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
			});
			
			var length = 4;
			
			flowSlick.on('beforeChange', function(slick,currentSlide,current,next) {
				let nextPos = this.querySelector('[data-slick-index="'+next+'"]').querySelector('.st-flow-list__item').dataset.pos;
				let target = slick.currentTarget;
				let wrap = target.closest('.st-flow');
				let count = target.dataset.count;
				if(count-length <= nextPos){
					wrap.classList.add('is-over');
				}else{
					wrap.classList.remove('is-over');
				}
			});
		}
		
		return;
		
		if (this.app.isSmartPhone()) {
			var labSlick = $('.cc-junior2__items');
			labSlick.slick({
				arrows: false,
				autoplay: true,
				autoplaySpeed: 2000,
				speed: 1200,
				cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
			});
			$('.cc-junior2 .slick-arr-l').click(e => {
				labSlick.slick('slickPrev');
			});
			$('.cc-junior2 .slick-arr-r').click(e => {
				labSlick.slick('slickNext');
			});
			
			var defaultOptions = {
				arrows: false,
				autoplay: true,
				autoplaySpeed: 1000,
				speed: 1000,
				cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
			};
			
			var evetSlick = $('.cc-output2__item-imgs');
			evetSlick.slick(defaultOptions);
			
			var projectDesignSlick = $('.cc-high3__list');
			projectDesignSlick.slick(defaultOptions);
			
			var sdgsSlick = $('.cc-color2__main-img');
			sdgsSlick.slick(defaultOptions);
			
			var awardSlick = $('.cc-award3__list');
			awardSlick.slick(defaultOptions);
			$('.cc-award3 .slick-arr-l').click(e => {
				awardSlick.slick('slickPrev');
			});
			$('.cc-award3 .slick-arr-r').click(e => {
				awardSlick.slick('slickNext');
			});
		}
	}
}
